module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAATlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////+QlxstAAAAGXRSTlMA4PO26bFAJSDavKmeZFlPShkPCNfMlZQ0bO/NWQAAAGtJREFUKM+90jkSgCAQRFEZVlHAXef+F9UpYzqgSn/6Eorp7vv8TtrVOfLTsdbYsNRPFVb8Ni6QWRXA0jBDZpMBSzZAZkqAJe0hM12QecOsIJNrfhql5m8xufkkqrTMAY/Jip7VKYYoQ/67G+48GjHJV2WeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/vocal/ic_play_audio.png
// module id = 6O9N
// module chunks = 0